module.exports = __webpack_public_path__ + "img/all_persons-large.fb7ce43d.webp";